import {Component, Input} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {ViewService} from '../../services/view/view.service';
import {DetailsHeader} from '../../generated/report-client';
import {UtilService} from '../../services/util/util.service';

export interface ReportTableConfig {
  headers?: Array<ReportTableHeader>;
  body: Array<ReportTableItem>;
  totals?: Array<ReportTableTotal>;
  internalArrayKey?: string;
  timezone?: string;
}
export interface ReportTableHeader {
  title: string;
  subTitle?: string;
  tooltip?: string;
  totalsKey?: string;
  symbol?: 'price' | 'amount';
  customClass?: string | string[] | Set<string> | {[p: string]: any};
}
export interface ReportTableItem {
  key: string;
  alternateKey?: string;
  secondaryKey?: string;
  useParent?: boolean;
  useRowSpan?: boolean;
  valueType?: ReportTableValueType;
  alternateValueType?: ReportTableValueType;
  hideSymbol?: boolean;
  translationKey?: string;
  subItem?: ReportTableItem;
}
export interface ReportTableTotal {
  key?: string;
  title?: string;
  valueType?: ReportTableValueType;
  hideSymbol?: boolean;
  translationKey?: string;
  colSpan?: number;
}
export type ReportTableValueType = 'text' | 'price' | 'percentage' | 'date' | 'period' | 'simple' | 'translation';
export interface ReportTableData<Type> {
  header?: DetailsHeader;
  data: Type[];
  total?: Record<any, any>;
}

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  styleUrls: ['./report-table.component.scss']
})
export class ReportTableComponent<Type> {
  @Input() public dataType: string;
  @Input() public tableConfig: ReportTableConfig;
  @Input() public tableData: ReportTableData<Type>;

  constructor(public authService: AuthService,
              public viewService: ViewService,
              public utilService: UtilService) {
  }

  public selectProperItem(item: any, tableItem: ReportTableItem): {value: any, type: ReportTableValueType} {
    if (tableItem.alternateKey && ((tableItem.secondaryKey && item[tableItem.alternateKey][tableItem.secondaryKey]) || (!tableItem.secondaryKey && item[tableItem.alternateKey]))) {
      return {value: tableItem.secondaryKey ? item[tableItem.alternateKey][tableItem.secondaryKey] : item[tableItem.alternateKey], type: tableItem.alternateValueType};
    }
    return {value: tableItem.secondaryKey ? item[tableItem.key][tableItem.secondaryKey] : item[tableItem.key], type: tableItem.valueType};
  }
}
